export default __webpack_public_path__ + "static/media/img-cannabis.9d162ce3.png";